module.exports = "<p>\n  world-surveys works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/world-surveys/world-surveys.component.html
// module id = ../../../../../src/app/dashboard/world-surveys/world-surveys.component.html
// module chunks = main